export default "__VITE_PUBLIC_ASSET__4a89e001__"